
import React, { Component, Fragment } from 'react';
import { Button } from 'reactstrap';
import Dialog from 'apa/containers/Dialog';
import autobind from 'autobind-decorator';
import * as locationActions from 'customers/actions/locations';
import { connect } from 'react-redux';

@connect(
    null,
    dispatch => {
        return {
            remove: (location) => dispatch(locationActions.remove(location)),
            fetchLocation: (customerId) => dispatch(locationActions.fetchLocation(customerId))
        }
    }
)
export default class DeleteLocation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isDeleteLocationModalOpen: false
        }
    }

    @autobind
    toggleDeleteLocationModal() {
        this.setState({
            ...this.state,
            isDeleteLocationModalOpen: !this.state.isDeleteLocationModalOpen
        })
    }

    @autobind
    confirmDeleteLocation() {
        Promise.resolve(this.props.remove(this.props.location))
            .then(() => {
                this.toggleDeleteLocationModal();
                window.location.reload();
            })
            .catch(error => {
                console.error('Error deleting location:', error);
            });
    }
    render() {
        return (
            <Fragment>
                <Button onClick={this.toggleDeleteLocationModal} color='danger'>
                    <i className='fa fa-trash'> </i>
                </Button>
                <Dialog
                    isOpen={this.state.isDeleteLocationModalOpen}
                    toggle={this.toggleDeleteLocationModal}
                    confirm={this.confirmDeleteLocation}
                    title={'Standort löschen'}
                >
                    Soll der Standort wirklich gelöscht werden?
                </Dialog>
            </Fragment>
        )
    }
}